<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Categories</h1>
                    <p>Gestion des méthodes de paiements</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.category.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une catégorie</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.category.export')" @click="exportFile('categories')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.category.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :menus="menus" active-nav="true" active-advanced-filter="false" active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div>
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Référence', value:'slug'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center"><span>Racine</span></div>
                            <div class="center"><span>Nbre de produits</span></div>
                            <div><span>Statut</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.category.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                    <icon name="git-branch-01" v-if="!item.picture"/>
                                    <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                </figure>
                            </div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="name">
                              <strong class="highlight">{{ item.name }}</strong>
                              <p>{{ item.headline }}</p>
                            </div>
                            <div data-field="sku">{{ item.slug }}</div>
                            <div class="center">{{ item.is_root }}</div>
                            <div class="center">{{ item.products }}</div>
                            <div><published v-model="item.published"></published></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.category.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.category.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import CategoryService from './CategoryService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                treeData: {
                    name: 'root',
                    children: []
                },
                menus: [
                    {
                        slug: 'category',
                        name: 'Categories'
                    },
                    {
                        slug: 'category-tree',
                        name: 'Tree'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
            this.getResource().tree().then((response) => {
                //console.log('tree', response);
                this.treeData.children = response.data;
            })
        },
        methods: {
            getResource: function(){
                return CategoryService;
            },
            consoleData () {
                //console.log(this.treeData)
            },
            changeState (item) {
                this.$set(item, '$foldClose', !item['$foldClose'])
            },
            changePosition (option) {
                console.log('changePosition: ', option)
            },
            recursive: function(data){
                let children = []
                for (let item of data) {
                    let child = this.recursive(item.children);
                    children.push({
                        id: item.id,
                        parent_id: item.parent_id,
                        depth: item.depth,
                        children: child
                    })
                }
                return children
            },
            saveTree(){
                let data = this.recursive(this.treeData.children);
                //console.log('tree', data)
                this.getResource().saveTree({data: data}).then((response) => {
                    //console.log('tree', response.data);
                    this.treeData.children = response.data
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/category/Index.vue